import { z } from 'zod';
export const ANALYTICS_APPS = ['auction', 'marketplace'];
export const AnalyticsAppSchema = z.enum(ANALYTICS_APPS);
export const AnalyticsAppFilterSchema = z.enum(['all', ...ANALYTICS_APPS]);
export const PageViewBeaconSchema = z.object({
    app: AnalyticsAppSchema,
    path: z.string().min(1).max(512).startsWith('/'),
    referrer: z.string().max(1024).optional(),
    utm: z
        .object({
        source: z.string().max(100).optional(),
        medium: z.string().max(100).optional(),
        campaign: z.string().max(200).optional(),
    })
        .optional(),
    screen: z.object({ w: z.number().int().min(0).max(10000), h: z.number().int().min(0).max(10000) }).optional(),
    locale: z.string().max(10).optional(),
});
export const AnalyticsDeviceSchema = z.enum(['desktop', 'mobile', 'tablet', 'unknown']);
const IsoDay = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
export const AnalyticsMetricsSchema = z.object({
    sessions: z.number().int().nonnegative(),
    pageViews: z.number().int().nonnegative(),
    uniqueVisitors: z.number().int().nonnegative(),
    uniqueUsers: z.number().int().nonnegative(),
    newVisitors: z.number().int().nonnegative(),
    avgSessionSec: z.number().nonnegative(),
});
export const AnalyticsDailyRowSchema = AnalyticsMetricsSchema.extend({
    date: IsoDay,
    app: AnalyticsAppFilterSchema,
});
export const AnalyticsSummaryQuerySchema = z.object({
    from: IsoDay,
    to: IsoDay,
    app: AnalyticsAppFilterSchema.default('all'),
});
export const AnalyticsSummarySchema = z.object({
    from: IsoDay,
    to: IsoDay,
    app: AnalyticsAppFilterSchema,
    totals: AnalyticsMetricsSchema,
    days: z.array(AnalyticsDailyRowSchema),
});
export const AnalyticsSessionUserSchema = z.object({
    id: z.string(),
    name: z.string().nullable(),
    email: z.string().nullable(),
});
export const AnalyticsSessionRowSchema = z.object({
    id: z.string(),
    app: AnalyticsAppSchema,
    visitorId: z.string(),
    user: AnalyticsSessionUserSchema.nullable(),
    isStaff: z.boolean(),
    startedAt: z.string(),
    lastAt: z.string(),
    durationSec: z.number().int().nonnegative(),
    pageCount: z.number().int().nonnegative(),
    entryPath: z.string(),
    referrerHost: z.string().nullable(),
    utmSource: z.string().nullable(),
    device: AnalyticsDeviceSchema,
    browser: z.string().nullable(),
    os: z.string().nullable(),
    isNewVisitor: z.boolean(),
});
const BoolParam = z.preprocess((v) => v === true || v === 'true' || v === '1', z.boolean());
export const AnalyticsSessionsQuerySchema = z.object({
    from: IsoDay.optional(),
    to: IsoDay.optional(),
    app: AnalyticsAppFilterSchema.default('all'),
    registeredOnly: BoolParam.default(false),
    includeStaff: BoolParam.default(false),
    userId: z.string().regex(/^[a-f0-9]{24}$/).optional(),
    cursor: z.string().max(100).optional(),
    limit: z.coerce.number().int().min(1).max(100).default(50),
});
export const AnalyticsSessionsPageSchema = z.object({
    items: z.array(AnalyticsSessionRowSchema),
    nextCursor: z.string().nullable(),
});
export const AnalyticsSessionPageViewSchema = z.object({ path: z.string(), at: z.string() });
export const AnalyticsUserVisitRowSchema = z.object({
    id: z.string(),
    name: z.string().nullable(),
    email: z.string().nullable(),
    lastSeenAt: z.string().nullable(),
    sessions30d: z.number().int().nonnegative(),
});
export const AnalyticsUsersPageSchema = z.object({
    items: z.array(AnalyticsUserVisitRowSchema),
    nextCursor: z.string().nullable(),
});
//# sourceMappingURL=analytics.js.map